module.exports = __webpack_public_path__ + "assets/40.jpg?b6f033741a7ea50bf2197a8b2638100a";